"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @param {Object} params
 * @param {String} params.name
 * @param {String} params.value
 */
var Personalization = function Personalization() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Personalization);

  this.name = params.name || 'Personalization';
  this.value = params.value || '';
};

module.exports = Personalization;